<ng-container *ngIf="isOldDesign; else isNewDS">
  <button
    role="button"
    aria-labelledby="acc-btnLikeOld"
    class="likeSnippet"
    [ngClass]="className"
    (click)="likeItems()"
    (keydown)="checkActivationButtonKeyService($event)"
  >
    <div class="likeSnippet__icon" [class.liked]="isLiked">
      <div class="likeSnippet__icon__heart" [ngClass]="{'likeSnippet__icon__heart--full': isLiked}"></div>
    </div>
    <div *ngIf="!isProductLike" class="likeSnippet__count">{{ likeCount }}</div>
    <div *ngIf="isBrandLike || isProductLike" class="likeSnippet__textCount" i18n="@@LIKE.I_LIKE">
      Like {{ likeCount }}
    </div>
    <p id="acc-btnLikeOld" class="visuallyhidden">
      <span i18n="@@LIKE.I_LIKE_ACCESSIBILITY">Like </span>{{ productName }}
    </p>
  </button>
</ng-container>

<ng-template #isNewDS>
  <button role="button" aria-labelledby="acc-btnLike" class="likeSnippet likeSnippet--vertical" (click)="likeItems()">
    <div class="likeSnippet__icon" [class.liked]="isLiked">
      <div class="likeSnippet__icon__heart"></div>
      <div class="vc-text-xs likeSnippet--vertical__count">
        <span>{{ likeCount }}</span>
      </div>
    </div>
    <p id="acc-btnLike" class="visuallyhidden"><span i18n="@@LIKE.I_LIKE_ACCESSIBILITY">Like</span>{{ productName }}</p>
  </button>
</ng-template>
